export { ClozeTableText } from './ClozeTableText';
